export interface CausePartyFormData {
  name: string;
  type: "petitioner" | "respondent";
}

export interface CauseAdvocateFormData {
  name: string;
  type: "petitioner" | "respondent";
  enrollment: string;
  userId?: string;
  lockedEnrollment?: boolean;
}

export interface CauseFormData {
  cnr: string;
  petitioner: string;
  respondent: string;
  advocatePetitioner: string;
  advocateRespondent: string;
  caseType: string;
  filingNumber: string;
  filingDate: string;
  registrationNumber: string;
  registrationDate: string;
  caseNumber: string;
  highcourt: string;
  courtRoom: string;
  courtRoomNo: string;
  caseStage: string;
  state: string;
  district: string;
  complex: string;
  establishment: string;
  hearingDate: string;
  courtType: string;
  hearingStatus?: string;
  bench: string;
  benchRoom: string;
  petitionerEnrollmentId: string;
  respondentEnrollmentId: string;
  parties: CausePartyFormData[];
  advocates: CauseAdvocateFormData[];
}

export const defaultCauseFormValues: CauseFormData = {
  cnr: "",
  petitioner: "",
  respondent: "",
  advocatePetitioner: "",
  advocateRespondent: "",
  caseType: "",
  filingNumber: "",
  filingDate: "",
  registrationNumber: "",
  registrationDate: "",
  caseNumber: "",
  highcourt: "",
  courtRoom: "",
  courtRoomNo: "",
  caseStage: "",
  state: "",
  district: "",
  complex: "",
  establishment: "",
  hearingDate: "",
  courtType: "",
  bench: "",
  benchRoom: "",
  petitionerEnrollmentId: "",
  respondentEnrollmentId: "",
  parties: [
    {
      name: "",
      type: "petitioner",
    },
    {
      name: "",
      type: "respondent",
    },
  ],
  advocates: [
    {
      name: "",
      type: "petitioner",
      enrollment: "",
    },
    {
      name: "",
      type: "respondent",
      enrollment: "",
    },
  ],
};

export const causeCaseTypes = [
  "Civil Suit",
  "Criminal Appeal",
  "Writ Petition",
  "Company Appeal",
  "Family Dispute",
  "Property Dispute",
  "Commercial Suit",
];

export const causeCaseStages = [
  "Filing",
  "Admission",
  "Notice",
  "Reply",
  "Evidence",
  "Appearence",
  "Final Decision",
  "Arguments",
  "Reserved",
  "Disposed",
];
